module.exports = __webpack_public_path__ + "assets/img/pay_ok.ef5a3218.png";